import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import './ErrorModal.css';

class ErrorModal extends Component {
    noClickHandler = () => {
        if (this.props.noClick) {
            this.props.noClick();
        }
    };

    yesClickHandler = () => {
        if (this.props.yesClick) {
            this.props.yesClick();
        } 
    };

    render() {
        let modalHeader = null;

        if (this.props.title) {
            modalHeader = (
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
            );
        }

        return (
            <Modal show={this.props.show} onHide={this.noClickHandler} backdrop="static">
                {modalHeader}
                {this.props.message &&
                    <Modal.Body>
                        {this.props.message}
                    </Modal.Body>
                }
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.noClickHandler}>{this.props.noText}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ErrorModal.defaultProps = {
    show: false,
    title: 'Error with Submission',
    noText: 'Close'
};

ErrorModal.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    noText: PropTypes.string,
    noClicked: PropTypes.func.isRequired
};

export default ErrorModal;
